import React, { useState, useCallback } from 'react';
import IconButton from '@mui/material/IconButton';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CircularProgress from '@mui/material/CircularProgress';
import { downloadFile, viewFile } from '../helpers';

export default function ViewDownloadIconButton({ id, fileType, fileName, fileExt }) {
  const [isLoading, setIsLoading] = useState(false);

  const onViewFile = useCallback((e) => {
    e.stopPropagation();
    setIsLoading(true);
    viewFile({ params: { id, fileType}, fileName, fileExt })
    .finally(() => setIsLoading(false));
  }, [id, fileType, fileName, fileExt]);

  const onDownloadFile = useCallback((e) => {
    e.stopPropagation();
    setIsLoading(true);
    downloadFile({ params: { id, fileType}, fileName, fileExt })
    .finally(() => setIsLoading(false));
  }, [id, fileType, fileName, fileExt]);

  return (
    isLoading ?
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 20 }}>
      <CircularProgress color="info" size={18} thickness={4}/>
    </div>
    :
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 20 }}>
      <IconButton
        size="small"
        sx={{ padding: 0 }}
        onClick={onViewFile}
      >
        {fileExt === 'pdf' ? <PictureAsPdfIcon fontSize="small"/> : <PhotoLibraryIcon fontSize="small"/>}
      </IconButton>
      <IconButton
        size="small"
        sx={{ padding: 0 }}
        onClick={onDownloadFile}
      >
        <FileDownloadIcon fontSize="small"/>
      </IconButton>
    </div>
  );
};
